export const SIGNAL_FINISH_CONTENT_RENDER = "SIGNAL_FINISH_CONTENT_RENDER";
export const SIGNAL_START_STOPWATCH = "SIGNAL_START_STOPWATCH";
export const SIGNAL_STOP_STOPWATCH = "SIGNAL_STOP_STOPWATCH";

export const FETCH_COURSES_ALL = "FETCH_COURSES_ALL";
export const FETCH_COURSES_BY_SEARCH = "FETCH_COURSES_BY_SEARCH";
export const FETCH_COURSE = "FETCH_COURSE";
export const FETCH_PREREQUISITES = "FETCH_PREREQUISITES";
export const CREATE_COURSE = "CREATE_COURSE";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const LOADING_START = "LOADING_START";
export const LOADING_END = "LOADING_END";

export const STORE_COURSE_STRUCTURE = "STORE_COURSE_STRUCTURE";
export const STORE_COURSE_TITLE = "STORE_COURSE_TITLE";
export const STORE_CONTENT_ITEMS = "STORE_CONTENT_ITEMS";
export const STORE_CONTENT = "STORE_CONTENT";
export const STORE_MAIN_DIALOG_CONTENT = "STORE_MAIN_DIALOG_CONTENT";
export const STORE_AND_UPDATE_CONTENT = "STORE_AND_UPDATE_CONTENT";

export const STORE_PROGRESS = "STORE_PROGRESS";
export const STORE_PROGRESS_CONTENT_LAST_SEEN =
  "STORE_PROGRESS_CONTENT_LAST_SEEN";
export const STORE_PROGRESS_UPDOWNVOTE = "STORE_PROGRESS_UPDOWNVOTE";
export const STORE_PROGRESS_ELAPSED_TIME = "STORE_PROGRESS_ELAPSED_TIME";
export const STORE_PROGRESS_REVIEW_PROGRESS = "STORE_PROGRESS_REVIEW_PROGRESS";
export const STORE_PROGRESS_ADD_BOOKMARK = "STORE_PROGRESS_ADD_BOOKMARK";
export const STORE_PROGRESS_EDIT_BOOKMARK = "STORE_PROGRESS_EDIT_BOOKMARK";
export const STORE_PROGRESS_DELETE_BOOKMARK = "STORE_PROGRESS_DELETE_BOOKMARK";
export const STORE_PROGRESS_ADD_HIGHLIGHT = "STORE_PROGRESS_ADD_HIGHLIGHT";
export const STORE_PROGRESS_DELETE_HIGHLIGHT =
  "STORE_PROGRESS_DELETE_HIGHLIGHT";
export const CLEAR_ALL_PROGRESS = "CLEAR_ALL_PROGRESS";

export const STORE_PROGRESS_CONTENT = "STORE_PROGRESS_CONTENT";
export const STORE_PROGRESS_PROBLEMS_TRIED = "STORE_PROGRESS_PROBLEMS_TRIED";
export const STORE_PROGRESS_NOTES = "STORE_PROGRESS_NOTES";

export const STORE_APP_EQUATION_CURRENT_INFO =
  "STORE_APP_EQUATION_CURRENT_INFO";
export const STORE_APP_COMMENT_CURRENT_INFO = "STORE_APP_COMMENT_CURRENT_INFO";
export const STORE_APP_NOTES_CURRENT_INFO = "STORE_APP_NOTES_CURRENT_INFO";

export const SET_KEYBOARD_AVAILABLE = "SET_KEYBOARD_AVAILABLE";
export const SET_SCROLL_AVAILABLE = "SET_SCROLL_AVAILABLE";

// Set comment is currently open
export const STORE_OPEN_COMMENT_ID = "STORE_OPEN_COMMENT_ID";
export const STORE_OPEN_PROBLEM_SET = "STORE_OPEN_PROBLEM_SET";
export const UPDATE_UPDOWNVOTE_TOTAL = "UPDATE_UPDOWNVOTE_TOTAL";
export const STORE_COMMENT = "STORE_COMMENT";
export const ADD_NEW_COMMENT = "ADD_NEW_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const ADD_NEW_COMMENT_REPLY = "ADD_NEW_COMMENT_REPLY";
export const EDIT_COMMENT_REPLY = "EDIT_COMMENT_REPLY";
export const DELETE_COMMENT_REPLY = "DELETE_COMMENT_REPLY";

// Support items
export const STORE_SUPPORT_ITEMS = "STORE_SUPPORT_ITEMS";
export const STORE_CURRENT_SUPPORT_ITEM = "STORE_CURRENT_SUPPORT_ITEM";
export const STORE_AND_PROCESS_SUPPORT = "STORE_AND_PROCESS_SUPPORT";
export const SET_SUPPORT_STATE = "SET_SUPPORT_STATE";
export const SET_SUPPORT_STATE_BY_INDEX = "SET_SUPPORT_STATE_BY_INDEX";
export const SET_SUPPORT_STATE_JUST_OPENED = "SET_SUPPORT_STATE_JUST_OPENED";
export const SET_SUPPORT_VISIBLE = "SET_SUPPORT_VISIBLE";
export const SET_SUPPORT_STATE_NEXT = "SET_SUPPORT_STATE_NEXT";
export const SET_SUPPORT_STATE_PREV = "SET_SUPPORT_STATE_PREV";

export const STORE_CURRENT_COMMENT_ITEM = "STORE_CURRENT_COMMENT_ITEM";
export const STORE_CURRENT_NOTES_ITEM = "STORE_CURRENT_NOTES_ITEM";
export const STORE_CURRENT_HIGHLIGHTED_ITEM = "STORE_CURRENT_HIGHLIGHTED_ITEM";
